// extracted by mini-css-extract-plugin
export default {"container":"Home_container__36mq4","body":"Home_body__0wQbw","landing":"Home_landing__3gZ9K"};